import { executeSQL } from "@carto/react-api";
import { CONNECTION } from "../config.js";
const TABLE = `${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_raw}`;

export const getVisitors = async ({
  credentials,
  opts,
  geoid = null,
  day_of_week,
  part_of_day,
}) => {
  var query = "";
  if (geoid === null) {
    query = `
        SELECT  SUM(n_visitors) as n_visitors
        FROM ${TABLE}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}'
      `;
  } else {
    query = `
        SELECT  SUM(n_visitors) as n_visitors
        FROM ${TABLE}
        WHERE geo_id = '${geoid}' AND day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}'
      `;
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data[0]
  );
};

export const getTravelledCountries = async ({
  credentials,
  opts,
  geoid = null,
  day_of_week,
  part_of_day,
}) => {
  var query = "";
  if (geoid === null) {
    query = `
        SELECT country as name, SUM(n_visitors_travelled_countries) as value
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.travelled_countries}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}'
        GROUP BY country ORDER BY value DESC LIMIT 10
      `;
  } else {
    query = `
        SELECT country as name, SUM(n_visitors_travelled_countries) as value
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.travelled_countries}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND geo_id = '${geoid}'
        GROUP BY country ORDER BY value DESC LIMIT 10
      `;
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data
  );
};

export const getVisitedBrands = async ({
  credentials,
  opts,
  geoid = null,
  day_of_week,
  part_of_day,
}) => {
  var query = "";
  if (geoid === null) {
    query = `
        SELECT brand as name, SUM(n_visitors_brand_visited) as value
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.brands_visited}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND n_visitors_brand_visited > 0
        GROUP BY brand ORDER BY value DESC LIMIT 10
      `;
  } else {
    query = `
        SELECT brand as name, SUM(n_visitors_brand_visited) as value  
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.brands_visited}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND geo_id = '${geoid}' AND n_visitors_brand_visited > 0
        GROUP BY brand ORDER BY value DESC LIMIT 10
      `;
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data
  );
};

export const getGeobehaviour = async ({
  credentials,
  opts,
  geoid = null,
  day_of_week,
  part_of_day,
}) => {
  var query = "";
  if (geoid === null) {
    query = `
        SELECT geo_behaviour as name, SUM(n_visitors_geo_behaviour) as value
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.geobehaviour}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND n_visitors_geo_behaviour > 0
        GROUP BY geo_behaviour ORDER BY value DESC LIMIT 10
      `;
  } else {
    query = `
        SELECT geo_behaviour as name, SUM(n_visitors_geo_behaviour) as value  
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.geobehaviour}
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND geo_id = '${geoid}' AND n_visitors_geo_behaviour > 0
        GROUP BY geo_behaviour ORDER BY value DESC LIMIT 10
      `;
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data
  );
};

export const getVisitorsList = async ({
  credentials,
  opts,
  geoid,
  day_of_week,
  part_of_day,
}) => {
  const query = `
    WITH data as(
        SELECT
        bqcarto.quadkey.QUADINT_FROMQUADKEY(geo_id) as quadint,
        geo_id,
        visitor_home_origin,
        day_of_week,
        part_of_day,
        n_visitors
        FROM ${TABLE}
        WHERE geo_id = '${geoid}' AND day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}'
        ),
        
        d as (select 
          array(
            select as struct 
              split(kv, ':')[offset(0)] as quadkey, 
              split(kv, ':')[offset(1)] as value 
            from unnest(split(translate(json_extract(c.visitor_home_origin, '$'), '{}"', ''))) kv
          ) as origins,
          day_of_week,
          part_of_day,
          geo_id,
          n_visitors
        from data c)
        
        SELECT
        d.geo_id as destination,
        samples_origins.quadkey,
        ST_X(bqcarto.quadkey.ST_GEOGPOINTFROMQUADINT(bqcarto.quadkey.QUADINT_FROMQUADKEY(samples_origins.quadkey))) as longitude,
        ST_Y(bqcarto.quadkey.ST_GEOGPOINTFROMQUADINT(bqcarto.quadkey.QUADINT_FROMQUADKEY(samples_origins.quadkey))) as latitude,
        CAST(samples_origins.value as decimal) * d.n_visitors as n_visitors
        
        FROM
          d, UNNEST(d.origins) AS samples_origins
    `;
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data
  );
};

export const getMinMaxQuantiles = async ({
  credentials,
  opts,
  geoid,
  buckets,
  day_of_week,
  part_of_day,
}) => {
  var query = "";

  if (!geoid) {
    query = `
    SELECT 
    MIN(n_visitors) as min,
    MAX(n_visitors) as max,
    APPROX_QUANTILES(n_visitors, ${buckets}) as quantiles
    FROM ${TABLE}
    WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}'
    `;
  } else {
    query = `
    SELECT 
    MIN(n_visitors) as min,
    MAX(n_visitors) as max,
    APPROX_QUANTILES(n_visitors, ${buckets}) as quantiles
    FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.origin_destination}
    WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND geo_id_destination = '${geoid}'
    `;
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data
  );
};

export const getMinMaxQuantilesEngland = async ({
  credentials,
  opts,
  geoid,
  buckets,
  day_of_week,
  part_of_day,
  isoline,
}) => {
  var query = "";

  if (!geoid && isoline.data) {
    query = `
    SELECT 
    MIN(n_visitors) as min,
    MAX(n_visitors) as max,
    APPROX_QUANTILES(n_visitors, ${buckets}) as quantiles
    FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_wide} 
    WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}' AND 
    ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
      isoline.data.geometry
    )}'))
    `;
  } else {
    return;
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data
  );
};

export const getVisitorsEngland = async ({
  credentials,
  opts,
  geoid = null,
  day_of_week,
  part_of_day,
  isoline,
}) => {
  var query = "";
  if (geoid === null && isoline.data) {
    query = `
        SELECT  SUM(n_visitors) as n_visitors
        FROM ${CONNECTION.project}.${CONNECTION.dataset}.${
      CONNECTION.table_wide
    } 
        WHERE day_of_week = '${day_of_week}' AND part_of_day = '${part_of_day}'
        AND ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
          isoline.data.geometry
        )}'))
      `;
  } else {
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data[0]
  );
};

export const getWeeklyData = async ({
  credentials,
  opts,
  day_of_week,
  part_of_day,
  isoline,
}) => {
  var query = "";
  if (isoline.data) {
    if (day_of_week === "All") {
      query = `
      SELECT * FROM
      (SELECT 
      day_of_week,
      SUM(n_visitors) as n_visitors
      FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_wide} 
      WHERE part_of_day = '${part_of_day}'
      AND ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
        isoline.data.geometry
      )}'))
      GROUP BY day_of_week)
      PIVOT
      (
        SUM(n_visitors)
        FOR day_of_week in ('Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday')
      )
    `;
    } else {
      query = `
      SELECT * FROM
      (SELECT 
      day_of_week,
      SUM(n_visitors) as n_visitors
      FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_wide} 
      WHERE part_of_day = '${part_of_day}' AND day_of_week = '${day_of_week}'
      AND ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
        isoline.data.geometry
      )}'))
      GROUP BY day_of_week)
      PIVOT
      (
        SUM(n_visitors)
        FOR day_of_week in ('Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday')
      )
    `;
    }
  } else {
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data[0]
  );
};

export const getDailyData = async ({
  credentials,
  opts,
  day_of_week,
  part_of_day,
  isoline,
}) => {
  var query = "";
  if (isoline.data) {
    if (part_of_day === "All") {
      query = `
      SELECT * FROM
      (SELECT 
      part_of_day,
      SUM(n_visitors) as n_visitors
      FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_wide} 
      WHERE day_of_week = '${day_of_week}'
      AND ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
        isoline.data.geometry
      )}'))
      GROUP BY part_of_day)
      PIVOT
      (
        SUM(n_visitors)
        FOR part_of_day in ('Morning', 'Afternoon', 'Evening', 'Night')
      )
    `;
    } else {
      query = `
      SELECT * FROM
      (SELECT 
      part_of_day,
      SUM(n_visitors) as n_visitors
      FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table_wide} 
      WHERE part_of_day = '${part_of_day}' AND day_of_week = '${day_of_week}'
      AND ST_Intersects(geom, ST_GeogFromGeoJSON('${JSON.stringify(
        isoline.data.geometry
      )}'))
      GROUP BY part_of_day)
      PIVOT
      (
        SUM(n_visitors)
        FOR part_of_day in ('Morning', 'Afternoon', 'Evening', 'Night')
      )
    `;
    }
  } else {
  }
  var connection = CONNECTION.connection;

  return executeSQL({ credentials, query, connection, opts }).then(
    (data) => data[0]
  );
};
